import { render, staticRenderFns } from "./AppProductPicker.vue?vue&type=template&id=2b42e081&scoped=true&"
import script from "./AppProductPicker.vue?vue&type=script&lang=js&"
export * from "./AppProductPicker.vue?vue&type=script&lang=js&"
import style0 from "./AppProductPicker.vue?vue&type=style&index=0&id=2b42e081&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42e081",
  null
  
)

export default component.exports